export const health_annual_report = [
  {
    id: 1,
    name: 'wcdhw-annual-report-2024-2025',
    summary: 'shortsummary/wcdhw-annual-report-2024-2025.html',
    link: 'wcdhw-annual-report-2024-2025.pdf',
    audio_en: 'audio/en/wcdhw-annual-report-2024-2025_en.mp3',
    audio_af: 'audio/af/wcdhw-annual-report-2024-2025_af.mp3',
    audio_xh: 'audio/xh/wcdhw-annual-report-2024-2025_xh.mp3'
  },
  {
    id: 2,
    name: 'wced-app-2023-2024',
    summary: 'shortsummary/wced-app-2023-2024.html',
    link: 'wced-app-2023-2024.pdf',
    audio_en: 'audio/en/wced-app-2023-2024_en.mp3',
    audio_af: 'audio/af/wced-app-2023-2024_af.mp3',
    audio_xh: 'audio/xh/wced-app-2023-2024_xh.mp3'
  }
];